import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { getQueryParams } from '@hglobal/common';
import { environment } from '@pt/environment';
import { Observable } from 'rxjs';

import { GetUserInfoRes } from '../models';
import { GetMemberCoursesReq, GetMemberCoursesRes } from '../models/get-member-courses';
import { CoursesReportApi } from './courses-report-api.interface';

@Injectable()
export class MyWardsCoursesReportApiService implements CoursesReportApi {
  readonly #httpClient = inject(HttpClient);
  readonly #baseUrl = `${environment.apiHost}lms-analytics/`;

  getUserInfo(userId: number): Observable<GetUserInfoRes> {
    return this.#httpClient.get<GetUserInfoRes>(`${environment.apiHost}user/admin/${userId}/`);
  }

  getMemberCourses(params: GetMemberCoursesReq): Observable<GetMemberCoursesRes> {
    return this.#httpClient.get<GetMemberCoursesRes>(
      `${this.#baseUrl}my-wards-course-status-report/${params.userId}/`,
      { params: getQueryParams(params) },
    );
  }
}
